import { find, propEq } from 'ramda'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import { PhoneNumberItem } from '@/app/module/phonenumbers'
import { tabNames } from '@/app/module/phonenumbers/component/item'
import NotFoundPage from '@/app/page/not-found'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps<{
    phoneNumberId: string
    tabName: string
  }>
}

function CampaignsItemPage({ match }: Props) {
  if (!find(propEq('value', match.params.tabName), tabNames)) {
    return <NotFoundPage />
  }
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Phone Number - engageSPARK">
        <AuthHeader currentPage={PAGE.PHONENUMBERS.ITEM} />
        <TotpGuard>
          <PhoneNumberItem phoneNumberId={match.params.phoneNumberId} tabName={match.params.tabName} />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}

export default CampaignsItemPage
